export { gwc_qs, gwc_qsa, gwc_delegate, gwc_on, gwc_parent, gwc_attr, gwc_find, CustomEvent, gwc_updateCartByCheckout }
import 'url-search-params-polyfill';

import 'formdata-polyfill';

// Get element using the selector.
function gwc_qs(selector, scope) {
    return (scope || document).querySelector(selector)
}

// Get all the selector.
function gwc_qsa(selector, scope) {
    return (scope || document).querySelectorAll(selector)
}

// addEventListener wrapper:
function gwc_on(target, type, callback, useCapture) {
    target.addEventListener(type, callback, !!useCapture)
}

// Attach a handler to event for all elements that match the selector, now or in
// the future, based on a root element
function gwc_delegate(target, selector, type, handler) {
    var useCapture = type === 'blur' || type === 'focus';
    gwc_on(target, type, dispatchEvent, useCapture);

    function dispatchEvent(event) {

        var targetElement = event.target;
        var potentialElements = gwc_qsa(selector, target);
        var hasMatch = Array.prototype.indexOf.call(potentialElements, targetElement) >= 0;

        if (hasMatch) {
            handler.call(targetElement, event)
        }
    }
}

// Get the parent of the element.
function gwc_parent(element, tagName) {
    if (!element.parentNode) {
        return undefined
    }
    if (element.parentNode.tagName.toLowerCase() === tagName.toLowerCase()) {
        return element.parentNode
    }
    return gwc_parent(element.parentNode, tagName)
}

/**
 * Find the child element.
 *
 * @since 1.0.0
 *
 * @param {Object} element
 * @param {string} className
 */
function gwc_find(element, className) {
    let child_node;

    if (!element.childNodes) {
        child_node = undefined;
    }

    Array.from(element.childNodes).forEach((child) => {
        if (undefined === child.classList) {
            return;
        }

        if (child.classList.contains(className)) {
            child_node = child;
        }
    });

    return child_node;
}

/**
 * Get the attribute from the selector.
 *
 * @since 1.0.0
 *
 * @param {int} form_id
 * @param {string} attr
 */
function gwc_attr(form_id, attr) {
    attr = attr || '';
    let form = gwc_qs('#give-wc-form-' + form_id);

    return null !== form ? form.getAttribute('data-' + attr) : false;
}

/**
 * IE Support
 *
 * @param {*} event
 * @param {*} params
 */
function CustomEvent(event, params) {
    params = params || { bubbles: false, cancelable: false, detail: undefined };
    let evt = document.createEvent('CustomEvent');
    evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
    return evt;
}

/**
 * If user forgot to click on the "Update Cart" button and direct
 * click on the "Proceed to checkout" button then append the selected
 * Give Donations to the Cart.
 *
 * https://github.com/impress-org/give-donation-upsells-woocommerce/issues/24
 *
 * @since 1.0.0
 *
 * @param {*} action
 * @param {*} formElement
 * @param {string} method
 */
function gwc_updateCartByCheckout(action, formElement, method = 'POST') {

    if (null === formElement) {
        return;
    }

    let formData = new FormData(formElement),
        convertedJSON = {};

    for (var [key, value] of formData.entries()) {
        convertedJSON[key] = value;
    }

    /**
     * We could pass "new FormData()" directly but it isn't support in IE browser
     * So passing form data as object.
     */
    let formParam = new URLSearchParams(convertedJSON);

    // Append action.
    formParam.append('action', action);

    return new Promise((resolve, reject) => {
        fetch(give_wc_vars.admin_ajax,
            {
                body: formParam.toString(),
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded"
                },
                method,
            }
        ).then((response) => {
            if (response.ok) {
                window.location.href = give_wc_vars.checkout_url;
            } else {
                throw new Error(give_wc_vars.checkout_error);
            }
        }).catch(err => {
            if (confirm(err)) {
                window.location.href = give_wc_vars.checkout_url
            }
        });
    });
}



// WEBPACK FOOTER //
// ./assets/src/js/modules/give-wc-helpers.js